import * as React from "react";
import AriaTooltip from "../../../../Shared/Tooltip/AriaTooltip";

export const SectionHeader = (title: string | JSX.Element, tooltipContent?: string | JSX.Element): JSX.Element => {
    return (
        <h3>
            <b>{title}</b>{" "}
            {tooltipContent && (
                <AriaTooltip showCloseButton={true} cssWrapper="is-info-icon">
                    {tooltipContent}
                </AriaTooltip>
            )}
        </h3>
    );
};
